import { scrollToElement } from '../util';

/**
 * As the name might guess this handler searches for invalid form elements and scrolls to the first one
 *
 * @param event
 */
const onSubmitScrollToInvalidElement = function (event) {
  const $invalidElements = $(event.delegateTarget).find(':invalid');
  if (!$invalidElements.length) return;

  scrollToElement({
    element: $invalidElements[0],
    scrollTopDifference: -20,
  });
};

$('form').on('click', '[type="submit"]', onSubmitScrollToInvalidElement);
